import { ALevelSubjectTestsConverter, ActConverter, ApTestsConverter, SatConverter } from '..';

export default class ConverterManager {
  static getConverter(type: string) {
    if (ALevelSubjectTestsConverter.is(type)) return ALevelSubjectTestsConverter;
    if (ActConverter.is(type)) return ActConverter;
    if (ApTestsConverter.is(type)) return ApTestsConverter;
    if (SatConverter.is(type)) return SatConverter;
  }

  static defaults() {
    return {
      ...ALevelSubjectTestsConverter.defaults(),
      ...ActConverter.defaults(),
      ...ApTestsConverter.defaults(),
      ...SatConverter.defaults(),
    };
  }
}
